<template>
  <v-card tile flat class="MyTrading" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-sheet class="d-flex align-center mb-4" :color="$vuetify.theme.dark ? '#162334 ' : 'transparent'">
            <div class="title">
              <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
              <span class="ml-2">My Trading Accounts</span>
            </div>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-sheet :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-card-text class="d-flex pt-3 trade">
              <div class="d-flex align-start pl-2 pb-3">
                <p class="ma-0">Live Accounts:</p>
              </div>
              <v-spacer></v-spacer>
              <router-link class="links" to="/mt5-accounts?tab=1">See All ></router-link>
            </v-card-text>
            <v-card-text class="d-flex pl-6 pb-2 trade align-center">
              <span class="number">{{ totalLiveAccounts }}</span>
              <v-spacer></v-spacer>
              <div>
                <v-menu rounded="0" transition="slide-x-transition" bottom right>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn color="greenMain" small tile elevation="0" class="ma-0 text-capitalize btn-account"
                      v-bind="attrs" v-on="on">
                      Create Account
                    </v-btn>
                  </template>
                  <v-card class="dropdown-menu-card" tile flat>
                    <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                      <v-list-item-group>
                        <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <router-link v-text="item.text" class="text-decoration-none" router
                              :to="item.link"></router-link>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-card-text>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-sheet :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-card-text class="d-flex pt-3 trade">
              <div class="d-flex align-start pl-2 pb-3">
                <v-spacer></v-spacer>
                <p class="ma-0">Demo Accounts:</p>
              </div>
              <v-spacer></v-spacer>
              <router-link class="links" to="/mt5-accounts?tab=5">See All ></router-link>
            </v-card-text>
            <v-card-text class="d-flex pl-6 pb-2 trade align-center">
              <span class="number">{{ demoAccounts?.length }}</span>
              <v-spacer></v-spacer>
              <v-btn small tile to="/create-demo-account" class="ma-0 text-capitalize btn-account" outlined
                :color="$vuetify.theme.dark ? 'transparent' : '#FF567F'">
                Create Account
              </v-btn>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
  data: () => ({
    items: [
      { text: "Create Live Account", icon: "mdi-signal", link: "/create-live-account" },
      { text: "Create Investor Account", icon: "mdi-currency-usd", link: "/create-investor-menu" },
      { text: "Create Manager Account", icon: "mdi-account-tie", link: "/create-manager-account" },
    ],
  }),
  computed: {
    ...mapState("trading", ["totalLiveAccounts", "demoAccounts"])
  },
  methods: {
    ...mapActions("trading", [
      TRADING__ACTIONS.TOTALLIVEACCOUNTS,
      TRADING__ACTIONS.DEMOACCOUNTS,
    ]),
  },
  async mounted() {
    await this[TRADING__ACTIONS.TOTALLIVEACCOUNTS]();
    await this[TRADING__ACTIONS.DEMOACCOUNTS]();
  },
};
</script>
